import $ from 'jquery';

if ($('.page-breadcrumbs__social').length) {
	$('.page-breadcrumbs__social a').click(function (e) {
		e.preventDefault();
		var share_container = $(this).parents('.page-breadcrumbs__social');
		var url_to_share = share_container.data('url');
		var title_to_share = share_container.data('title');
		var share_url = '';

		var open_window = true;

		if ($(this).hasClass('mail')) {
			open_window = false;
			share_url = 'mailto:?subject=' + title_to_share + '&body=' + url_to_share;
		} else if ($(this).hasClass('facebook')) {
			share_url = 'https://www.facebook.com/sharer.php?u=' + url_to_share;
		} else if ($(this).hasClass('twitter')) {
			share_url = 'https://twitter.com/share?text=' + title_to_share + '&url=' + url_to_share;
		} else if ($(this).hasClass('linkedin')) {
			share_url = 'https://www.linkedin.com/shareArticle?mini=true&url=' + url_to_share + '&title=' + title_to_share;
		}

		if (open_window && share_url !== '') {
			window.open(share_url, 'Share this', 'width=520, height=460');
		} else if (share_url !== '') {
			window.location = share_url;
		}
	});
}